import { useState, useEffect } from 'react';
import { getContractors, createContractor, updateContractor, deleteContractor } from '../utils/api';
import toast from 'react-hot-toast';

const empty = { company_name: '', contact_name: '', phone: '', email: '', address: '', license_num: '', status: 'Active' };
const FIELDS = [
  ['company_name', 'Company Name'],
  ['contact_name', 'Contact Name'],
  ['phone', 'Phone'],
  ['email', 'Email'],
  ['address', 'Address'],
  ['license_num', 'License #'],
];

export default function Contractors() {
  const [list, setList] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => { getContractors().then(setList); }, []);

  function openAdd() { setEditing(null); setForm(empty); setShowModal(true); }
  function openEdit(c) { setEditing(c); setForm({ ...c }); setShowModal(true); }

  async function handleSave() {
    if (!form.company_name?.trim()) return toast.error('Company name required');
    try {
      if (editing) {
        const updated = await updateContractor(editing.id, form);
        setList(l => l.map(c => c.id === editing.id ? updated : c));
        toast.success('Contractor updated');
      } else {
        const created = await createContractor(form);
        setList(l => [...l, created]);
        toast.success('Contractor added');
      }
      setShowModal(false);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error saving');
    }
  }

  async function handleDelete(id, name) {
    if (!window.confirm(`Delete ${name}?`)) return;
    await deleteContractor(id);
    setList(l => l.filter(c => c.id !== id));
    toast.success('Deleted');
  }

  return (
    <>
      <div className="page-header">
        <h2>Contractors</h2>
        <button className="btn btn-primary" onClick={openAdd}>+ Add Contractor</button>
      </div>

      <div className="page-body">
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Company</th>
                <th>Contact</th>
                <th>Phone</th>
                <th>Email</th>
                <th>License #</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {list.map(c => (
                <tr key={c.id}>
                  <td className="td-name">{c.company_name}</td>
                  <td>{c.contact_name || '—'}</td>
                  <td>{c.phone || '—'}</td>
                  <td style={{ fontSize: '0.8rem' }}>{c.email || '—'}</td>
                  <td>{c.license_num || '—'}</td>
                  <td>
                    <span className={c.status === 'Active' ? 'badge badge-active' : 'badge badge-cancelled'}>
                      {c.status}
                    </span>
                  </td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    <button className="btn btn-ghost btn-sm" onClick={() => openEdit(c)}>Edit</button>
                    <button className="btn btn-ghost btn-sm" style={{ color: 'var(--red-500)' }} onClick={() => handleDelete(c.id, c.company_name)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{editing ? 'Edit Contractor' : 'Add Contractor'}</h3>
              <button className="btn btn-ghost btn-sm" onClick={() => setShowModal(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-grid form-grid-2">
                {FIELDS.map(([f, l]) => (
                  <div key={f} className={`form-group${f === 'address' ? ' form-full' : ''}`}>
                    <label className="form-label">{l}</label>
                    <input
                      className="form-input"
                      value={form[f] || ''}
                      onChange={e => setForm(x => ({ ...x, [f]: e.target.value }))}
                    />
                  </div>
                ))}
                <div className="form-group">
                  <label className="form-label">Status</label>
                  <select className="form-select" value={form.status} onChange={e => setForm(x => ({ ...x, status: e.target.value }))}>
                    <option>Active</option>
                    <option>Inactive</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-outline" onClick={() => setShowModal(false)}>Cancel</button>
              <button className="btn btn-primary" onClick={handleSave}>Save</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
